<template>
    <div class="mt-4 mb-4">
        <b-row>
            <b-col lg="7" sm="12">
                <b-card>
                    <h3 class="strong">Add New Calculation</h3>
                    <hr />
                    <b-row class="mb-4">
                        <b-col md="4">
                            <b-form-text>Well Name</b-form-text>
                            <b-form-input v-model="wellName" maxLength="50" autocomplete="off" />
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Field Name</b-form-text>
                            <b-form-input v-model="fieldName" maxLength="50" autocomplete="off" />
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Date</b-form-text>
                            <b-form-input type="date" v-model="date" autocomplete="off" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="6">
                            <b-form-text>Company Name</b-form-text>
                            <b-form-input v-model="companyName" maxLength="50" autocomplete="off" />
                        </b-col>
                        <b-col md="6">
                            <b-form-text>Engineer Name</b-form-text>
                            <b-form-input v-model="engineerName" maxLength="50" autocomplete="off" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="6">
                            <b-form-text>Well Type</b-form-text>
                            <b-form-select v-model="wellType" :options="optWellType" />
                        </b-col>
                        <b-col md="6">
                            <b-form-text>Instrument</b-form-text>
                            <b-form-select v-model="instrument" :options="optInstrument" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="6">
                            <b-form-text>Unit Measurement</b-form-text>
                            <b-form-select v-model="unit" :options="optUnit" />
                        </b-col>
                        <b-col md="6">
                            <b-form-text>Calculation Method</b-form-text>
                            <b-form-select v-model="method" :options="optMethod" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="12">
                            <b-form-text>Comment / Description</b-form-text>
                            <b-form-input v-model="comment" maxLength="100" autocomplete="off" />
                            <b-form-text class="right">{{ commentRemainingLength }} / 100</b-form-text>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" style="text-align: end">
                            <b-btn variant="primary" :disabled="isSubmitting || disableSubmit" @click="didTapSubmit">{{ isSubmitting ? "Processing..." : "Save & Continue" }}&ensp;<font-awesome-icon icon="arrow-alt-circle-right" /></b-btn>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "create",
    data() {
        return {

            wellName: "",
            fieldName: "",
            date: "",
            companyName: "",
            engineerName: "",
            wellType: "Vertical",
            instrument: "Downhole Sensor",
            unit: "Feet (ft)",
            method: "Straight Line",
            comment: "",

            optWellType: ["Vertical", "Directional"],
            optInstrument: ["Downhole Sensor", "Sonolog"],
            optUnit: ["Feet (ft)", "Meter (m)"],
            optMethod: ["Straight Line", "Vogel"],

            isSubmitting: false

        }
    },
    methods: {

        didTapSubmit() {
            let payload = {
                name: this.wellName,
                field: this.fieldName,
                date: this.date,
                company: this.companyName,
                engineer: this.engineerName,
                type: this.wellType,
                instrument: this.instrument,
                unit: this.unit == "Feet (ft)" ? "ft" : "m",
                method: this.method,
                comment: this.comment
            }

            this.isSubmitting = true
            this.$axios.post("/calc", payload).then(response => {
                
                this.isSubmitting = false
                let res = response.data
                if(res.message == "OK") {

                    // Reset core
                    this.$core.id = res.data.id
                    this.$core.general = {}
                    this.$core.input = {}
                    this.$core.dirtyInput = {}
                    this.$core.output = {}
                    this.$core.pump = {}
                    this.$core.equipment = {}
                    this.$core.trajectory = {}
                    this.$core.attachment.ipr = false
                    this.$core.attachment.pump = false
                    this.$core.idConstraint = 0
                    
                    this.$router.push("/input")

                }
                else {
                    this.$helper.toastError(this, res.message)
                }

            })
            .catch(() => {
                this.isSubmitting = false
                this.$helper.toastError(this, 'Failed to create a new calculation, please retry!')
            })
        }

    },
    computed: {

        commentRemainingLength() {
            return 100 - this.comment.length
        },

        disableSubmit() {
            return !(this.wellName != "" ) // && this.date != "" && this.companyName != "" && this.engineerName != "")
        }

    },
    created: function() {
        // Today's date
        let date = new Date()
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        this.date = date.toJSON().slice(0, 10)
    }
}
</script>

<style scoped>
    .right {
        text-align: end;
    }

    .smallAlert {
        margin-bottom: 1px;
        height: 38px;
        line-height: 38px;
        padding: 0px 15px;
    }
</style>